const authMethods = Object.freeze({
  Unset: 1,
  Code: 2,
  Exam: 3
});
export default authMethods;
